import { render, staticRenderFns } from "./addSetmeal.vue?vue&type=template&id=03d442e8&scoped=true"
import script from "./addSetmeal.vue?vue&type=script&lang=ts"
export * from "./addSetmeal.vue?vue&type=script&lang=ts"
import style0 from "./addSetmeal.vue?vue&type=style&index=0&id=03d442e8&prod&lang=scss"
import style1 from "./addSetmeal.vue?vue&type=style&index=1&id=03d442e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d442e8",
  null
  
)

export default component.exports